<p-confirmDialog
  header="Confirm Action"
  icon="fa fa-exclamation-triangle"
  [style]="{ width: '425px' }"
  acceptLabel="Yes"
  rejectLabel="No"
></p-confirmDialog>

<div class="command-bar">
  <i class="fa fa-search command-icon"></i>
  <label class="command-label" for="searches">Searches:</label>
  <p-dropdown
    id="searches"
    name="savedSearches"
    [options]="savedSearchesOptions"
    [(ngModel)]="selectedSearch"
    styleClass="filterItem"
    [style]="{ width: '300px' }"
    (onChange)="selectSearch($event)"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span>{{ item.labelValue }}</span>
    </ng-template>
    <ng-template let-object pTemplate="item">
      <span
        [pTooltip]="
          object.isGlobal
            ? 'This search is visible to all users'
            : 'This search is only visible to you'
        "
      >
        <i class="{{ object.label }}" style="width: 20px; text-align: center"></i
        ><span style="width: 100%" class="dropdown-item">{{ object.labelValue }}</span></span
      >
    </ng-template>
  </p-dropdown>

  <button
    [disabled]="noFilters()"
    class="ui-sm-12 mt-1"
    icon="fa fa-save"
    type="button"
    (click)="saveSearchDialog()"
    label="Save Selected Filter(s)"
    pButton
  ></button>
  <span
    *ngIf="this.loadedSearch && this.loadedSearch.isGlobal"
    pTooltip="You cannot delete global searches"
  >
    <button
      [disabled]="
        noFilters() || !this.loadedSearch || (this.loadedSearch && this.loadedSearch.isGlobal)
      "
      class="ui-sm-12 mt-1 red-btn"
      icon="fa fa-trash"
      type="button"
      (click)="deleteSearch()"
      label="Delete Search"
      pButton
    ></button>
  </span>
  <span *ngIf="!(this.loadedSearch && this.loadedSearch.isGlobal)">
    <button
      [disabled]="
        noFilters() || !this.loadedSearch || (this.loadedSearch && this.loadedSearch.isGlobal)
      "
      class="ui-sm-12 mt-1 red-btn"
      icon="fa fa-trash"
      type="button"
      (click)="deleteSearch()"
      label="Delete Search"
      pButton
    ></button>
  </span>
</div>

<p-dialog
  header="Save Search"
  [(visible)]="displaySaveDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '650px' }"
>
  <form [formGroup]="saveSearchForm" (ngSubmit)="saveSearch()" autocomplete="off">
    <div class="ui-grid ui-grid-responsive ui-fluid">
      <div class="ui-g-12">
        <div class="ui-g-4"><label for="searchName">Search Name</label></div>
        <div class="ui-g-8"><input pInputText id="searchName" formControlName="searchName" /></div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4">&nbsp;</div>
        <div
          class="ui-g-8 search-info"
          *ngIf="this.saveSearchForm.controls['searchName'].value"
          [ngStyle]="{ color: isNewSearch ? 'rgb(51,51,51)' : 'darkred' }"
        >
          {{
            isNewSearch
              ? 'This will be saved as a new search'
              : 'This will overwrite the existing search'
          }}
        </div>
        <div
          class="ui-g-8 search-info"
          *ngIf="!this.saveSearchForm.controls['searchName'].value"
          [ngStyle]="{ color: 'darkred' }"
        >
          Enter a name for the search
        </div>
      </div>
      <div class="ui-g-12">
        <div class="ui-g-4">&nbsp;</div>
        <div class="ui-g-8">
          <p-checkbox
            [disabled]="globalLocked"
            name="isGlobal"
            id="isGlobal"
            formControlName="isGlobal"
            binary="true"
            [pTooltip]="
              globalLocked
                ? 'A global search cannot be changed to a user-specific search'
                : 'Check this to allow all system users to see this search'
            "
          >
          </p-checkbox>
          <label for="isGlobal">Can search be viewed by everyone?</label>
        </div>
      </div>
    </div>
    <div style="float: right">
      <button
        type="submit"
        class="green-btn"
        pButton
        icon="fa ui-icon-check"
        label="Save"
        [disabled]="saveSearchForm.invalid"
      ></button>
      <button
        type="button"
        pButton
        icon="fa ui-icon-close"
        label="Cancel"
        (click)="closeDialog()"
      ></button>
    </div>
  </form>
</p-dialog>
